import styled from 'styled-components'

export interface PillBadgeProps {
  size?: string
  color: string
}

const PillBadge = styled.span<PillBadgeProps>`
  line-height: 9px;
  display: inline-block;
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors[props.color]};
  font-size: 9px;
  border-radius: 10px;
  text-transform: uppercase;
  vertical-align: middle;
  margin-right: 8px;
  padding: ${props => (props.size === 'small' ? '0px 2px' : '3px 7px')};
  border: 1px solid ${props => props.theme.colors[props.color]};
`

export default PillBadge



// WEBPACK FOOTER //
// ./src/components/Badge/index.tsx